export const GET_ROLES_BEGIN = "roles/GET_ROLES_BEGIN";
export const GET_ROLES_SUCCESS = "roles/GET_ROLES_SUCCESS";
export const GET_ROLES_FAILURE = "roles/GET_ROLES_FAILURE";
export const SAVE_ROLE_BEGIN = "roles/SAVE_ROLE_BEGIN";
export const SAVE_ROLE_SUCCESS = "roles/SAVE_ROLE_SUCCESS";
export const SAVE_ROLE_FAILURE = "roles/SAVE_ROLE_FAILURE";
export const DELETE_ROLE_BEGIN = "roles/DELETE_ROLE_BEGIN";
export const DELETE_ROLE_SUCCESS = "roles/DELETE_ROLE_SUCCESS";
export const DELETE_ROLE_FAILURE = "roles/DELETE_ROLE_FAILURE";
